import MissionProgressBar from "../MissionProgressBar";
import { MissionInfoRowStyled } from "./styled";
import { formatDisplayNumber } from "utils/functions/number";

const MissionInfoRow = ({ labelTh, labelEn, value, unit, percent, showBar = true, valuePrefix }) => (
  <MissionInfoRowStyled>
    <div className="top_row">
      <div className="labels">
        <div className="label_th">{labelTh}</div>
        <div className="label_en">{labelEn}</div>
      </div>
      <div className="value_unit">
        <span className="value_prefix">{valuePrefix}</span>
        <span className="value">{formatDisplayNumber(value)}</span>
        {unit ? <span className="unit">{unit}</span> : null}
      </div>
    </div>
    {showBar &&
      <MissionProgressBar percent={percent} height={20} />
    }
  </MissionInfoRowStyled>
);

export default MissionInfoRow;
